import React, { useState } from 'react';
import PropTypes from 'prop-types';

const SoloPartImage = ({ part, fullSize = false }) => {
    const [rotate, setRotate] = useState(false);

    const handleImageLoad = ({ target }) => {
        const { naturalWidth, naturalHeight } = target;

        if (naturalWidth < naturalHeight) {
            setRotate(true);
        }
    };

    const transformSx = fullSize
        ? { transformOrigin: 'top left', transform: 'rotate(90deg) translateX(0%) translateY(-100%)', maxWidth: '6.9in', maxHeight: '8in', width: '100%', height: 'auto' } // css magic to rotate fullSize image and expand width and height
        : { transformOrigin: 'top left', transform: 'rotate(90deg) translateX(0.2in) translateY(-100%)' }; // css magic to rotate small images

    return <img src={part?.file_url} onLoad={handleImageLoad}
        style={{
            // default
            maxWidth: '100%', maxHeight: '100%', margin: '0 auto', objectFit: 'contain',
            // rotate?
            ...rotate && transformSx
        }}
    />;
};


SoloPartImage.propTypes = {
    part: PropTypes.object,
    styles: PropTypes.object,
    fullSize: PropTypes.bool
};

export default SoloPartImage;